<div>
  <!-- <app-go-back-and-title titulo="Nuevo Expediente"></app-go-back-and-title> -->
  <h2>Nuevo Expediente</h2>

  <ngx-spinner [zIndex]="100" name="spExpediente" bdColor="rgba(255,255,255,0.8)" size="default"
    color="var(--primary-color)" type="ball-atom" [fullScreen]="false"></ngx-spinner>

  <mat-card appearance="outlined" class="stepper-container">
    <mat-card-content>
      <mat-stepper linear #stepper="matStepper" orientation="horizontal" class="expediente-stepper">

        <!-- Step 1: Información Básica -->
        <mat-step [stepControl]="informacionBasicaForm" label="Información Básica"
          [completed]="informacionBasicaForm.valid">
          <ng-template matStepLabel>
            <mat-icon>info</mat-icon>
            Información Básica
          </ng-template>

          <div class="step-content">
            <div class="step-header">
              <h3>Datos Principales del Expediente</h3>
              <p class="step-description">Complete la información esencial para identificar el expediente</p>
            </div>

            <form [formGroup]="informacionBasicaForm">
              <mat-card appearance="outlined" class="form-section">
                <mat-card-header>
                  <div mat-card-avatar>
                    <mat-icon>search</mat-icon>
                  </div>
                  <mat-card-title>Caso Asociado</mat-card-title>
                  <mat-card-subtitle>Seleccione el caso al cual pertenece este expediente o genere uno caso
                    nuevo.</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                  <div class="row">
                    <div class="col-lg-10">
                      <app-buscar-caso (eventEntity)="selectCaso($event)"></app-buscar-caso>
                    </div>
                    <div class="col-lg-2">
                      <app-btn-nuevo-caso></app-btn-nuevo-caso>
                    </div>
                  </div>
                  <app-caso-detail-card [caso]="casoDto"></app-caso-detail-card>
                </mat-card-content>
              </mat-card>

              <mat-card appearance="outlined" class="form-section">
                <mat-card-header>
                  <div mat-card-avatar>
                    <mat-icon>description</mat-icon>
                  </div>
                  <mat-card-title>Identificación del Expediente</mat-card-title>
                  <mat-card-subtitle>Información principal para identificar el expediente</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>

                  <div class="row">
                    <div class="col-lg-10">



                      <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Carátula</mat-label>
                        <mat-icon matIconPrefix>title</mat-icon>
                        <input matInput type="text" maxlength="200" style="text-transform: uppercase"
                          formControlName="Caratula" placeholder="Ingrese la carátula del expediente" />
                        <mat-hint>Nombre completo del expediente</mat-hint>
                        <mat-error *ngIf="informacionBasicaForm.get('Caratula')?.hasError('required')">
                          La carátula es <strong>requerida</strong>
                        </mat-error>
                        <mat-error *ngIf="informacionBasicaForm.get('Caratula')?.hasError('maxlength')">
                          Máximo 200 caracteres
                        </mat-error>
                      </mat-form-field>


                    </div>
                    <div class="col-lg-2">
                      <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Separador</mat-label>
                        <mat-icon matIconPrefix>more_horiz</mat-icon>
                        <input matInput type="text" maxlength="1" formControlName="SeparadorCaratula" />
                        <mat-hint>Caracter separador. Ej: /</mat-hint>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="form-grid">
                    <mat-form-field appearance="outline">
                      <mat-label>Identificador Único</mat-label>
                      <mat-icon matIconPrefix>fingerprint</mat-icon>
                      <input matInput type="text" formControlName="IdentificadorUnico" />
                      <mat-hint>CUIJ/IPP/SAE/N° de Causa/Etc.</mat-hint>
                      <mat-error *ngIf="informacionBasicaForm.get('IdentificadorUnico')?.hasError('required')">
                        El identificador único es <strong>requerido</strong>
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>Sufijo</mat-label>
                      <mat-icon matIconPrefix>label_outline</mat-icon>
                      <input matInput type="text" maxlength="200" style="text-transform: uppercase"
                        formControlName="Sufijo" placeholder="Sufijo del expediente" />
                      <mat-hint>Identificador adicional</mat-hint>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>Bis</mat-label>
                      <mat-icon matIconPrefix>content_copy</mat-icon>
                      <input matInput type="text" maxlength="200" style="text-transform: uppercase"
                        formControlName="Bis" placeholder="Identificador bis" />
                      <mat-hint>Para expedientes duplicados</mat-hint>
                    </mat-form-field>
                  </div>
                  <div class="form-grid">
                    <mat-form-field appearance="outline">
                      <mat-label>Demanda</mat-label>
                      <mat-icon matIconPrefix>person</mat-icon>
                      <input matInput type="text" maxlength="200" style="text-transform: uppercase"
                        formControlName="Demanda" placeholder="Parte demandante" />
                      <mat-hint>Quien inicia la acción legal</mat-hint>
                      <mat-error *ngIf="informacionBasicaForm.get('Demanda')?.hasError('required')">
                        El campo es <strong>requerido</strong>
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>Demandado</mat-label>
                      <mat-icon matIconPrefix>person_outline</mat-icon>
                      <input matInput type="text" maxlength="200" style="text-transform: uppercase"
                        formControlName="Demandado" placeholder="Parte demandada" />
                      <mat-hint>Contra quien se dirige la acción</mat-hint>
                      <mat-error *ngIf="informacionBasicaForm.get('Demandado')?.hasError('required')">
                        El campo es <strong>requerido</strong>
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>Causa</mat-label>
                      <mat-icon matIconPrefix>gavel</mat-icon>
                      <input matInput type="text" maxlength="200" style="text-transform: uppercase"
                        formControlName="Causa" placeholder="Motivo de la causa" />
                      <mat-hint>Razón o motivo del proceso</mat-hint>
                      <mat-error *ngIf="informacionBasicaForm.get('Causa')?.hasError('required')">
                        El campo es <strong>requerido</strong>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </mat-card-content>
              </mat-card>
            </form>

            <div class="step-actions">
              <button mat-button [routerLink]="['/expedientes']">
                Cancelar
              </button>
              <button mat-raised-button color="primary" [disabled]="!informacionBasicaForm.valid" matStepperNext>
                <mat-icon>navigate_next</mat-icon>
                Continuar
              </button>
            </div>
          </div>
        </mat-step>

        <!-- Step 2: Detalles del Expediente -->
        <mat-step [stepControl]="detallesExpedienteForm" label="Detalles del Expediente"
          [completed]="detallesExpedienteForm.valid">
          <ng-template matStepLabel>
            <mat-icon>assignment</mat-icon>
            Detalles
          </ng-template>

          <div class="step-content">
            <div class="step-header">
              <h3>Clasificación y Partes del Expediente</h3>
              <p class="step-description">Configure el tipo, estado y partes involucradas</p>
            </div>

            <form [formGroup]="detallesExpedienteForm">
              <mat-card appearance="outlined" class="form-section">
                <mat-card-header>
                  <div mat-card-avatar>
                    <mat-icon>category</mat-icon>
                  </div>
                  <mat-card-title>Clasificación</mat-card-title>
                  <mat-card-subtitle>Tipo y estado del expediente</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                  <div class="form-grid">
                    <mat-form-field appearance="outline">
                      <mat-label>Número de Expediente</mat-label>
                      <mat-icon matIconPrefix>numbers</mat-icon>
                      <input matInput type="text" maxlength="200" style="text-transform: uppercase"
                        formControlName="Numero" placeholder="Ej: 001/2024" />
                      <mat-hint>Número asignado por el juzgado</mat-hint>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>Tipo de Expediente</mat-label>
                      <mat-icon matIconPrefix>label</mat-icon>
                      <mat-select formControlName="TipoExpediente">
                        <ngx-spinner [zIndex]="-1" name="spTiposExpedientes" bdColor="rgba(255,255,255,0.8)"
                          size="small" color="var(--primary-color)" type="line-scale"
                          [fullScreen]="false"></ngx-spinner>
                        <mat-option [value]="tipoExpediente.id"
                          *ngFor="let tipoExpediente of tiposExpedientes; trackBy: trackByItems">
                          {{ tipoExpediente.descripcion }}
                        </mat-option>
                      </mat-select>
                      <mat-hint>Clasificación del tipo de proceso</mat-hint>
                      <mat-error *ngIf="detallesExpedienteForm.get('TipoExpediente')?.hasError('required')">
                        El campo es <strong>requerido</strong>
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>Estado del Expediente</mat-label>
                      <mat-icon matIconPrefix>track_changes</mat-icon>
                      <mat-select formControlName="EstadoExpedientes">
                        <ngx-spinner [zIndex]="-1" name="spEstadosExpediente" bdColor="rgba(255,255,255,0.8)"
                          size="small" color="var(--primary-color)" type="line-scale"
                          [fullScreen]="false"></ngx-spinner>
                        <mat-option [value]="estadoExpediente.id"
                          *ngFor="let estadoExpediente of estadosExpedientes; trackBy: trackByItems">
                          {{ estadoExpediente.descripcion }}
                        </mat-option>
                      </mat-select>
                      <mat-hint>Estado actual del expediente</mat-hint>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>Estado Procesal</mat-label>
                      <mat-icon matIconPrefix>timeline</mat-icon>
                      <mat-select formControlName="EstadoProcesal">
                        <ngx-spinner [zIndex]="-1" name="spEstadosProcesal" bdColor="rgba(255,255,255,0.8)" size="small"
                          color="var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
                        <mat-option [value]="estadoProcesal.id"
                          *ngFor="let estadoProcesal of estadosProcesal; trackBy: trackByItems">
                          {{ estadoProcesal.descripcion }}
                        </mat-option>
                      </mat-select>
                      <mat-hint>Etapa procesal actual</mat-hint>
                      <mat-error *ngIf="detallesExpedienteForm.get('EstadoProcesal')?.hasError('required')">
                        El campo es <strong>requerido</strong>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </mat-card-content>
              </mat-card>

              <mat-card appearance="outlined" class="form-section">
                <mat-card-header>
                  <div mat-card-avatar>
                    <mat-icon>people</mat-icon>
                  </div>
                  <mat-card-title>Partes del Proceso</mat-card-title>
                  <mat-card-subtitle>Información sobre las partes involucradas</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                  <app-select-usuarios-empresa [label]="'Creado por'"
                    (usuarioSeleccionado)="onCreadoPorSeleccionado($event)"></app-select-usuarios-empresa>
                  <p>Se podran asignar las demas partes en el proceso posterior.</p>
                </mat-card-content>
              </mat-card>
            </form>

            <div class="step-actions">
              <button mat-button matStepperPrevious>
                <mat-icon>navigate_before</mat-icon>
                Anterior
              </button>
              <button mat-raised-button color="primary" [disabled]="!detallesExpedienteForm.valid" matStepperNext>
                <mat-icon>navigate_next</mat-icon>
                Continuar
              </button>
            </div>
          </div>
        </mat-step>

        <!-- Step 3: Información Adicional -->
        <mat-step [stepControl]="informacionAdicionalForm" label="Información Adicional"
          [completed]="informacionAdicionalForm.valid">
          <ng-template matStepLabel>
            <mat-icon>more_horiz</mat-icon>
            Adicional
          </ng-template>

          <div class="step-content">
            <div class="step-header">
              <h3>Información Complementaria</h3>
              <p class="step-description">Datos adicionales y referencias del expediente</p>
            </div>

            <form [formGroup]="informacionAdicionalForm">
              <mat-card appearance="outlined" class="form-section">
                <mat-card-header>
                  <div mat-card-avatar>
                    <mat-icon>place</mat-icon>
                  </div>
                  <mat-card-title>Ubicación y Fechas</mat-card-title>
                  <mat-card-subtitle>Información sobre ubicación física y temporal</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                  <div class="form-grid">
                    <mat-form-field appearance="outline">
                      <mat-label>Ubicación</mat-label>
                      <mat-icon matIconPrefix>location_on</mat-icon>
                      <input matInput type="text" maxlength="200" style="text-transform: capitalize"
                        formControlName="Ubicacion" placeholder="Ubicación física del expediente" />
                      <mat-hint>Donde se encuentra físicamente</mat-hint>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>Fecha de Ingreso</mat-label>
                      <mat-icon matIconPrefix>event</mat-icon>
                      <input matInput [matDatepicker]="picker" formControlName="FechaIngresoMEU"
                        placeholder="Seleccione una fecha" />
                      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                      <mat-hint>Fecha de ingreso al sistema</mat-hint>
                    </mat-form-field>
                  </div>
                  <app-selec-juzgado [jurisdiccionInicial]="jurisdiccionInicial" [fueroInicial]="fueroInicial"
                    [juzgadoInicial]="juzgadoInicial" (juzgadoSeleccionado)="onJuzgadoSeleccionado($event)">
                  </app-selec-juzgado>
                </mat-card-content>
              </mat-card>

              <mat-card appearance="outlined" class="form-section">
                <mat-card-header>
                  <div mat-card-avatar>
                    <mat-icon>vpn_key</mat-icon>
                  </div>
                  <mat-card-title>Referencias y Montos</mat-card-title>
                  <mat-card-subtitle>Claves de sistema y valores monetarios</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                  <div class="form-grid">
                    <mat-form-field appearance="outline">
                      <mat-label>Clave</mat-label>
                      <mat-icon matIconPrefix>key</mat-icon>
                      <input matInput [type]="mostrarClave ? 'text' : 'password'" formControlName="ClaveExpediente"
                        placeholder="Clave del sistema" />
                      <button mat-icon-button matIconSuffix type="button" (click)="toggleMostrarClave()"
                        [attr.aria-label]="'Mostrar clave'" [attr.aria-pressed]="mostrarClave">
                        <mat-icon>{{mostrarClave ? 'visibility_off' : 'visibility'}}</mat-icon>
                      </button>
                      <mat-hint>Sistema de Gestión de Expedientes</mat-hint>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>URL Gestion</mat-label>
                      <mat-icon matIconPrefix>http</mat-icon>
                      <input matInput type="text" formControlName="UrlGestion"
                        placeholder="https://sisfe.justiciasantafe.gov.ar/" />
                      <mat-hint>URL del sistema de gestion</mat-hint>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>Monto Demanda</mat-label>
                      <mat-icon matIconPrefix>attach_money</mat-icon>
                      <input type="text" currencyMask placeholder="0,00" formControlName="MontoDemanda" matInput />
                      <mat-hint>Valor económico de la demanda</mat-hint>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>Tipo Moneda</mat-label>
                      <mat-icon matIconPrefix>attach_money</mat-icon>
                      <mat-select formControlName="IdTipoMonedaMontoDemanda">
                        <ngx-spinner [zIndex]="-1" name="spTiposMoneda" bdColor="rgba(255,255,255,0.8)" size="small"
                          color="var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
                        <mat-option [value]="tipoMoneda.id"
                          *ngFor="let tipoMoneda of tiposMoneda; trackBy: trackByItems">
                          {{ tipoMoneda.descripcion |titlecase }}
                        </mat-option>
                      </mat-select>
                      <mat-hint>Seleccione el tipo de moneda</mat-hint>
                    </mat-form-field>


                  </div>
                </mat-card-content>
              </mat-card>
            </form>

            <div class="step-actions">
              <button mat-button matStepperPrevious>
                <mat-icon>navigate_before</mat-icon>
                Anterior
              </button>
              <button mat-raised-button color="primary" matStepperNext [disabled]="!informacionAdicionalForm.valid">
                <mat-icon>navigate_next</mat-icon>
                Continuar
              </button>
            </div>
          </div>
        </mat-step>

        <!-- Step 4: Descripción y Resumen -->
        <!-- Step 4: Descripción y Resumen -->
<mat-step [stepControl]="descripcionForm" label="Finalizar" [completed]="descripcionForm.valid">
  <ng-template matStepLabel>
    <mat-icon>check_circle</mat-icon>
    Finalizar
  </ng-template>

  <div class="step-content">
    <div class="step-header">
      <h3>Descripción y Resumen Final</h3>
      <p class="step-description">Agregue detalles adicionales y revise la información</p>
    </div>

    <form [formGroup]="descripcionForm">
      <mat-card appearance="outlined" class="form-section">
        <mat-card-header>
          <div mat-card-avatar>
            <mat-icon>notes</mat-icon>
          </div>
          <mat-card-title>Descripción Adicional</mat-card-title>
          <mat-card-subtitle>Información complementaria del expediente</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Descripción</mat-label>
            <mat-icon matIconPrefix>subject</mat-icon>
            <textarea matInput #message name="Descripcion" formControlName="Descripcion" rows="4"
              placeholder="Agregue información adicional relevante..."></textarea>
            <mat-hint align="start">Amplíe información sobre el expediente</mat-hint>
            <mat-hint align="end">{{ message.value.length }} / 2000</mat-hint>
            <mat-error *ngIf="descripcionForm.get('Descripcion')?.hasError('maxlength')">
              Máximo 2000 caracteres
            </mat-error>
          </mat-form-field>
        </mat-card-content>
      </mat-card>
    </form>

    <!-- Resumen Final Compacto -->
    <mat-card appearance="outlined" class="form-section resumen-expediente">
      <mat-card-header>
        <div mat-card-avatar>
          <mat-icon>summarize</mat-icon>
        </div>
        <mat-card-title>Resumen del Expediente</mat-card-title>
        <mat-card-subtitle>Revise la información antes de crear el expediente</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>

        <!-- Información Principal -->
        <div class="resumen-principal">
          <div class="expediente-titulo">
            <h4>{{ getSummaryValue('Caratula') || 'Carátula no especificada' }}</h4>
            <div class="expediente-badges">
              <mat-chip-set>
                <mat-chip class="chip-cuij" *ngIf="getSummaryValue('IdentificadorUnico')">
                  <mat-icon>fingerprint</mat-icon>
                  {{ getSummaryValue('IdentificadorUnico') }}
                </mat-chip>
                <mat-chip class="chip-numero" *ngIf="getSummaryValue('Numero')">
                  <mat-icon>numbers</mat-icon>
                  N° {{ getSummaryValue('Numero') }}
                </mat-chip>
              </mat-chip-set>
            </div>
          </div>
        </div>

        <!-- Grid de Información -->
        <div class="resumen-grid">

          <!-- Caso y Partes -->
          <div class="resumen-card">
            <div class="card-header">
              <mat-icon>search</mat-icon>
              <span>Caso y Partes</span>
            </div>
            <div class="card-content">
              <div class="info-row">
                <strong>Caso:</strong>
                <span>{{ casoDto?.descripcion || 'No seleccionado' }}</span>
              </div>
              <div class="info-row">
                <strong>Demanda:</strong>
                <span>{{ getSummaryValue('Demanda') || 'No especificado' }}</span>
              </div>
              <div class="info-row">
                <strong>Demandado:</strong>
                <span>{{ getSummaryValue('Demandado') || 'No especificado' }}</span>
              </div>
              <div class="info-row">
                <strong>Causa:</strong>
                <span>{{ getSummaryValue('Causa') || 'No especificado' }}</span>
              </div>
            </div>
          </div>

          <!-- Clasificación -->
          <div class="resumen-card">
            <div class="card-header">
              <mat-icon>category</mat-icon>
              <span>Clasificación</span>
            </div>
            <div class="card-content">
              <div class="info-row">
                <strong>Tipo:</strong>
                <span>{{ getTipoExpedienteName(getSummaryValue('TipoExpediente')) }}</span>
              </div>
              <div class="info-row">
                <strong>Estado:</strong>
                <span>{{ getEstadoExpedienteName(getSummaryValue('EstadoExpedientes')) }}</span>
              </div>
              <div class="info-row">
                <strong>Procesal:</strong>
                <span>{{ getEstadoProcesalName(getSummaryValue('EstadoProcesal')) }}</span>
              </div>
            </div>
          </div>

          <!-- Ubicación y Fechas -->
          <div class="resumen-card">
            <div class="card-header">
              <mat-icon>place</mat-icon>
              <span>Ubicación y Fechas</span>
            </div>
            <div class="card-content">
              <div class="info-row">
                <strong>Juzgado:</strong>
                <span>{{ getJuzgadoName(getSummaryValue('Juzgado')) }}</span>
              </div>
              <div class="info-row">
                <strong>Ubicación:</strong>
                <span>{{ getSummaryValue('Ubicacion') || 'No especificada' }}</span>
              </div>
              <div class="info-row">
                <strong>Fecha Ingreso:</strong>
                <span>{{ getSummaryValue('FechaIngresoMEU') | date:'dd/MM/yyyy' }}</span>
              </div>
            </div>
          </div>

          <!-- Información Adicional -->
          <div class="resumen-card">
            <div class="card-header">
              <mat-icon>more_horiz</mat-icon>
              <span>Información Adicional</span>
            </div>
            <div class="card-content">
              <div class="info-row" *ngIf="getSummaryValue('ClaveExpediente')">
                <strong>Clave expediente:</strong>
                <span>{{ getSummaryValue('ClaveExpediente') }}</span>
              </div>
              <div class="info-row" *ngIf="getSummaryValue('MontoDemanda')">
                <strong>Monto:</strong>
                <span>{{ getSummaryValue('MontoDemanda') | currency:'ARS':'symbol':'1.2-2' }}</span>
              </div>
              <div class="info-row" *ngIf="getSummaryValue('TipoMoneda')">
                <strong>Tipo de moneda:</strong>
                <span>{{ getSummaryValue('TipoMoneda') | titlecase }}</span>
              </div>
              <div class="info-row" *ngIf="getSummaryValue('Sufijo')">
                <strong>Sufijo:</strong>
                <span>{{ getSummaryValue('Sufijo') }}</span>
              </div>
              <div class="info-row" *ngIf="getSummaryValue('Bis')">
                <strong>Bis:</strong>
                <span>{{ getSummaryValue('Bis') }}</span>
              </div>
            </div>
          </div>

        </div>

        <!-- Descripción (si existe) -->
        <div class="resumen-descripcion" *ngIf="getSummaryValue('Descripcion')">
          <div class="descripcion-header">
            <mat-icon>description</mat-icon>
            <span>Descripción</span>
          </div>
          <div class="descripcion-content">
            <p>{{ getSummaryValue('Descripcion') }}</p>
          </div>
        </div>

        <!-- Alertas de Validación -->
        <div class="resumen-alertas" *ngIf="!isFormularioCompleto()">
          <mat-icon color="warn">warning</mat-icon>
          <span>Revise que todos los campos requeridos estén completos</span>
        </div>

      </mat-card-content>
    </mat-card>

    <div class="step-actions">
      <button mat-button matStepperPrevious>
        <mat-icon>navigate_before</mat-icon>
        Anterior
      </button>
      <app-button-add [loading]="isLoading" (click)="onSubmit()" [disabled]="!isFormularioCompleto()">
      </app-button-add>
    </div>
  </div>
</mat-step>
      </mat-stepper>
    </mat-card-content>
  </mat-card>
</div>
